import Swal from 'sweetalert2';

export const handleDeleteNote = async (noteId, fetchNotes) => {
  if (!noteId) {
    console.error('ID de note invalide');
    return;
  }

  const confirmation = await Swal.fire({
    title: 'Êtes-vous sûr ?',
    text: "Vous ne pourrez pas annuler cette action !",
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    confirmButtonText: 'Supprimer',
    cancelButtonText: 'Annuler'
  });

  if (!confirmation.isConfirmed) {
    return;
  }

  try {
    const response = await fetch(`/api/delete-note/${noteId}`, {
      method: 'DELETE',
      credentials: 'include'
    });

    if (!response.ok) {
      throw new Error('Erreur lors de la suppression de la note');
    }

    fetchNotes();
  } catch (error) {
    console.error('Erreur lors de la suppression:', error);
    await Swal.fire({
      title: 'Erreur !',
      text: 'Une erreur est survenue lors de la suppression de la note.',
      icon: 'error',
      confirmButtonText: 'OK'
    });
  }
};

export const calculateNotePeriod = () => {
  const currentDate = new Date();
  const startDate = currentDate.toISOString().split('T')[0];
  const endDate = new Date(currentDate.setMonth(currentDate.getMonth() + 12))
    .toISOString()
    .split('T')[0];
  return { startDate, endDate };
};

export const handleNoteCreation = async (title, navigate) => {
  const { startDate, endDate } = calculateNotePeriod();

  try {
    const response = await fetch('/api/create-note', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ title, startDate, endDate })
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || 'Erreur lors de la création de la note');
    }

    navigate(`/get-expenses/${data.id}`);

    return true;
  } catch (error) {
    console.error('Erreur lors de la création de la note:', error);
    await Swal.fire({
      icon: 'error',
      title: 'Erreur',
      text: 'Une erreur est survenue lors de la création de la note.',
      confirmButtonText: 'OK',
      customClass: {
        confirmButton: 'custom-confirm-button'
      }
    });
    return false;
  }
}; 
